export enum EntityTypeEnum {
  Legal = 1,
  Individual = 2,
}
